import Header from "../../../../Components/Header/Header";
import Sidebar from "../../../../Components/Sidebar/Sidebar";
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../Helper/Context";
import { DailyPreventiveWorkExportTableDataAPI, DailyPreventiveWorkTableDataAPI } from "../../../../Redux/GardenDashboardSlice/DailyPreventiveWorkSlice";
import ViewURL from "../../../../Components/ViewURL/ViewURL";
import { Pegination } from "../../../../Components/Pegination/Pegination";
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL";
import { WardNameDDLAPI } from "../../../../Redux/DDLSlice";
import moment from "moment";
import { Loading } from "../../../../Helper/Loading";
import { GardenDailyPreWorkPendingExportData } from "./GardenDailyPreWorkPendingExportData";
import { TableNote } from "../../../../Components/Note/Note";
import AfterWorkPhoto from "../../../../Components/ViewURL/AfterWorkPhoto";

export default function GardenDailyPreWorkPending() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")

    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // console.log(HMonth)
    // console.log(MLable)

    const d = new Date();
    let month = d.getMonth();

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [FromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))

    // var lastYear = moment().subtract(1, 'years').endOf('week').startOf('day');
    // moment().subtract(1, 'years').endOf('week').startOf('day')

    // console.log("fromDate", moment(HMonth,'MM').year(HYear,'YYYY' ).startOf('month'))

    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    // console.log(moment(HMonth, 'MM').year(HYear, 'YYYY').endOf('month').format('YYYY-MM-DD'))

    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [showWorkImagePopup, setshowWorkImagePopup] = React.useState(false)
    const [AfterWorkPhotoData, setAfterWorkPhotoData] = React.useState('')
    const [workPhotoData, setworkPhotoData] = React.useState('')
    const [workGridData, setworkGridData] = React.useState('')

    const [ImageHeading, setImageHeading] = useState('')

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })


    // const YearMonth = () => {
    //     console.log( HMonth, HYear)
    //     console.log(moment().startOf('month').format('M'), moment().format('YYYY'))

    //     if (((moment().startOf('month').format('M')) == HMonth) && (moment().format('YYYY') == HYear)) {
    //         console.log("if" )
    //         setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
    //         setToDate(moment().format('YYYY-MM-DD'))
    //     } else {
    //         console.log("else" )
    //         setFromDate(moment(HMonth, 'M').year(HYear, 'YYYY').startOf('month').format('YYYY-MM-DD'))
    //         setToDate(moment(HMonth, 'M').year(HYear, 'YYYY').startOf('month').format('YYYY-MM-DD'))

    //     }

    // }

    // useEffect(() => {
    //     YearMonth()
    // }, [FromDate, ToDate])

    // console.log(moment().startOf('month').format('YYYY-MM-DD'))
    // console.log(moment(HMonth, 'M').year(HYear, 'YYYY').startOf('month').format('YYYY-MM-DD'))

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })

        // console.log("call")
    }

    // useEffect(() => {
    //     if (FromDate != moment().startOf('month').format('YYYY-MM-DD')) {
    //         setToDate(moment(HMonth, 'MM').year(HYear, 'YYYY').endOf('month').format('YYYY-MM-DD'))
    //     }
    // }, [FromDate])

    const handlePost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const handleShowAfterImage = (img) => {
        setshowWorkImagePopup(true)
        setworkGridData(img)
        setworkPhotoData(img?.beforeWorkPhoto)
        setAfterWorkPhotoData(img?.afterWorkPhoto)
    }

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            M_WardID: WardName.ID,
            FromkDate: FromDate,
            TokDate: ToDate,
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            Flag: ApiFlag,

        }
        // if (YearValue !== 0) {
        dispatch(DailyPreventiveWorkTableDataAPI({ data }))
        // }

    }, [IsPost, To, IsClear, isSearch])
    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            M_WardID: WardName.ID,
            FromkDate: FromDate,
            TokDate: ToDate,
            M_UsersID: UserID,
            token: token,
            From: '1',
            To: '99999',
            Flag: ApiFlag,

        }
        // if (YearValue !== 0) {
        dispatch(DailyPreventiveWorkExportTableDataAPI({ data }))
        // }

    }, [IsPost, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.DailyPreventiveWorkTableData)
    const { DailyPreventiveWorkTableData, isExportLoading } = useSelector(state => state.DailyPreventiveWorkExportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [WardName.ID])

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })
    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    DashboardHeading="Garden Maintainance"
                    setYearValue={setYearValue}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div id="" className="content1 content">
                        <div className="data_mob">
                            <div className="row m-1 pb-4 master_border">
                                <div className="col-8">
                                    <h5 className="ps-1 py-2">Daily Preventive Work {searchName}</h5>
                                </div>
                                <div className="col-4 mt-2">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            // DailyPreventiveWorkTableData && DailyPreventiveWorkTableData.table && DailyPreventiveWorkTableData.table.length 
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <GardenDailyPreWorkPendingExportData
                                                ExcelData={DailyPreventiveWorkTableData}
                                                name='Daily Preventive Work ${searchName}'
                                                searchName={searchName}
                                            />
                                    }
                                </div>
                                <div className="row m-0">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12">

                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-3 col-lg-3">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            onChange={(e) => (setFromDate(e.target.value))}
                                                            max={moment().format('YYYY-MM-DD')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>To Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="ToDate"
                                                            value={ToDate}
                                                            onChange={(e) => setToDate(e.target.value)}
                                                            max={moment().format('YYYY-MM-DD')}
                                                            min={moment(FromDate).format('YYYY-MM-DD')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />
                                                </div>
                                                <div className="col-12 col-lg-3 col-md-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>

                                            <div className="row mob_table table-responsive pt-1">
                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Date</th>
                                                            <th>Sector Name	 </th>
                                                            <th>Garden Name</th>
                                                            <th>Work Sub Type</th>
                                                            <th>Work Name</th>
                                                            <th>Before Work <br />Photo</th>
                                                            {
                                                                searchName == 'Completed' ?
                                                                    <th>After Work <br />Photo</th>
                                                                    :
                                                                    <></>
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.beforeWorkDate ? moment(item.beforeWorkDate).format("DD-MM-YYYY") : '-'}</td>
                                                                    <td>{item.sectorName ? item.sectorName : '-'}</td>
                                                                    <td>{item.gardenName ? item.gardenName : '-'}</td>
                                                                    <td>{item.workSubTypeName ? item.workSubTypeName : '-'}</td>
                                                                    <td>{item.workname ? item.workname : '-'}</td>
                                                                    <td className="ps-5">
                                                                        {
                                                                            (item.beforeWorkPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye" title='View'
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => (
                                                                                            handleShowImage(item.beforeWorkPhoto),
                                                                                            setImageHeading('Before Work Photo')
                                                                                        )}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    {
                                                                        searchName == 'Completed' ?
                                                                            <td className="ps-5">
                                                                                {
                                                                                    (item.afterWorkPhoto == null) ?
                                                                                        <span>-</span>
                                                                                        :
                                                                                        <>
                                                                                            <i className="fa-solid fa-eye" title='View'
                                                                                                style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                                onClick={() => (
                                                                                                    handleShowAfterImage(item),
                                                                                                    setImageHeading('After Work Photo')
                                                                                                )}
                                                                                            ></i>
                                                                                        </>
                                                                                }
                                                                            </td>
                                                                            :
                                                                            <></>
                                                                    }

                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {
                    showImagePopup ?
                        <ViewURL
                            Heading={ImageHeading}
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''

                }

                {
                    showWorkImagePopup ?
                        <AfterWorkPhoto
                            Heading={ImageHeading}
                            setshowWorkImagePopup={setshowWorkImagePopup}
                            workPhotoData={workPhotoData}
                            AfterWorkPhotoData={AfterWorkPhotoData}
                            workGridData={workGridData}
                            Flag = "WorkNameHeading"
                            LatLongFlag = "LatLongFlag"
                        />
                        : ''
                }
            </div>

        </>

    )

}